import React, { useEffect, useState } from 'react';
import { ViewerPropertiesComplete } from '../model';
import { useResource } from './common/useResource';
import { ProviderResult, providerToContentsShape, rootNodeID } from './common/compressed/index';
import { PureNodeTree, NodeTreeState } from '@myua/nodetree';
import { IconCompressed } from './common/Icons';
import { CompressedDownloadLinkPlugin } from './common/compressed/CompressedDownloadLinkPlugin';
import { FakeCHNode } from './common/compressed/index';
export const MediaCompressed: React.FC<ViewerPropertiesComplete> = ({
  filename,
  compressedFileTreeProvider,
}) => {
  const { data, error, errorMessage } = useResource<ProviderResult>(
    compressedFileTreeProvider?.loadTreeURL,
  );
  const [treeShape, setTreeShape] = useState<NodeTreeState<FakeCHNode>>({
    contents: {},
    viewState: {
      error,
      loaded: data !== undefined,
      rootNodeID: null,
      selectedNode: null,
    },
  });

  useEffect(() => {
    if (error || data === undefined) {
      setTreeShape({
        contents: {},
        viewState: {
          error,
          errorMessage,
          loaded: data !== undefined,
          rootNodeID: null,
          selectedNode: null,
        },
      });
    } else {
      const contents: NodeTreeState<FakeCHNode>['contents'] = providerToContentsShape(
        data,
        filename,
      );
      setTreeShape({
        contents,
        viewState: {
          error: false,
          loaded: true,
          rootNodeID: rootNodeID,
          selectedNode: rootNodeID,
        },
      });
    }
  }, [data, error, filename, errorMessage]);

  const onNodeClicked = (selectedNode: number) => {
    setTreeShape((ts) => ({
      contents: ts.contents,
      viewState: { ...ts.viewState, selectedNode },
    }));
  };
  const onTreeExpanderClicked = (nodeID: number) => {
    setTreeShape((ts) => {
      const descriptor = ts.contents[nodeID];

      const contents: NodeTreeState<FakeCHNode>['contents'] = {
        ...ts.contents,
        [nodeID]: { ...descriptor, expanded: !descriptor.expanded },
      };
      return {
        contents,
        viewState: ts.viewState,
      };
    });
  };

  return (
    <div className="gen-media-compressed">
      <PureNodeTree<
        FakeCHNode,
        {
          fileURLGetter: (path: string) => string;
        }
      >
        rootIcon={<IconCompressed />}
        canExpandCreativeFolders
        error={error}
        errorMessage={errorMessage}
        loaded={error === false && data !== undefined}
        showFiles
        rootNodeID={treeShape.viewState.rootNodeID}
        context={treeShape}
        // Кнопка Open у записей архива — плагин. Когда скачивание архива закрыто
        // (лицензии его шрифтов не одобрены), плагин не подключаем: дерево со структурой
        // остаётся, открыть/извлечь отдельный файл нельзя.
        plugins={
          compressedFileTreeProvider?.openEntriesAllowed === false
            ? []
            : [CompressedDownloadLinkPlugin]
        }
        pluginsMeta={{ fileURLGetter: compressedFileTreeProvider!.fileURLGetter }}
        onNodeClicked={onNodeClicked}
        onTreeExpanderClicked={onTreeExpanderClicked}
      />
    </div>
  );
};
